import * as React from 'react';

interface Props {
  url: string;
  locale: string;
  size: 'small' | 'large';
}

export const FacebookShareButton = ({ url, locale, size }: Props) => {
  const [hasScript, setHasScript] = React.useState<boolean>(false);

  const encodedUrl = encodeURI(url);

  React.useEffect(() => {
    const script = document.createElement('script');

    script.src = `https://connect.facebook.net/${locale.replace(
      '-',
      '_'
    )}/sdk.js#xfbml=1&version=v11.0&appId=554692133306072&autoLogAppEvents=1`;
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.onload = () => {
      setHasScript(true);
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  React.useEffect(() => {
    const win = window as any;
    if (win.FB && hasScript) {
      try {
        win.FB.XFBML.parse();
      } catch (e) {
        console.error(e);
      }
    }
  }, [hasScript]);

  return (
    <div>
      <div
        className="fb-like"
        data-href={encodedUrl}
        data-width=""
        data-layout="button_count"
        data-action="like"
        data-size={size}
        data-share="true"
      ></div>
    </div>
  );
};
